import React from 'react';
import ReactPaginate from 'react-paginate';
import './Pagination.scss';

const Pagination = ({
    pageCount,
    pageNumber,
    onPageChangeClick,
    ...props
}) => (
    <ReactPaginate
        pageCount={pageCount}
        onPageChange={onPageChangeClick}
        forcePage={pageNumber}
        {...props}
    />
)

Pagination.propTypes = {
    // pageCount: PropTypes.number,
    // onPageChangeClick: PropTypes.func
};

Pagination.defaultProps = {
    breakLabel: '...',
    marginPagesDisplayed: 1,
    pageRangeDisplayed: 2,
    previousLabel: "",
    nextLabel: "",
    breakClassName: "PaginationSearch__Item PaginationSearch__Item--Dots",
    containerClassName: "PaginationSearch",
    pageClassName: "PaginationSearch__Item",
    pageLinkClassName: "PaginationSearch__Link",
    activeClassName: "PaginationSearch__Item--Current",
    previousClassName: "PaginationSearch__Item PaginationSearch__Item--Arrow",
    nextClassName: "PaginationSearch__Item PaginationSearch__Item--Arrow",
    disabledClassName: "PaginationSearch__Item PaginationSearch__Item--Disabled",
    previousLinkClassName: "PaginationSearch__Arrow PaginationSearch__Arrow--Prev",
    nextLinkClassName: "PaginationSearch__Arrow PaginationSearch__Arrow--Next",
};

export default Pagination;
